const initialState = {
  title: null,
  data: null,
  filterTerm: '',
  forceExpandTriggered: false
}

export default (state = initialState, action) => {
  switch (action.type) {
    case 'SCOPE_DROPDOWN_FORCE_EXPAND_TRIGGERED':
      return { ...state, forceExpandTriggered: action.payload }
    case 'SCOPE_DROPDOWN_TITLE_REQUEST':
      return { ...state, title: null }
    case 'SCOPE_DROPDOWN_TITLE_RESPONSE':
      return { ...state, title: action.payload }
    case 'SCOPE_DROPDOWN_DATA_REQUEST':
      return { ...state, data: null }
    case 'SCOPE_DROPDOWN_DATA_RESPONSE':
      return { ...state, data: action.payload }
    case 'SCOPE_DROPDOWN_MORE_DATA_RESPONSE': {
      const { data, scope } = action.payload
      const newData = state.data[scope].data.concat(data.data)

      return {
        ...state,
        data: {
          ...state.data,
          [scope]: {
            data: newData,
            next_page: data.next_page
          }
        }
      }
    }
    case 'SCOPE_DROPDOWN_UPDATE_FILTER_TERM':
      return { ...state, filterTerm: action.payload }
    case 'SCOPE_DROPDOWN_RESET_DATA':
      return { ...state, data: null }
    case 'SCOPE_DROPDOWN_ANY_USER_GROUPS':
      return { ...state, anyUserGroups: action.payload }
    default:
      return state
  }
}
